module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "urban-1.eed0ef37.jpeg";